<div
  class="map-control-btn search-button-wrapper no-border"
  [ngClass]="{ 'mobile-btn': isMobile, expanded: expanded, collapsed: !expanded }"
  title="{{ T.settings.location_manager.click_here_search_for_location | translate }}"
>
  <div style="height: 100%; display: flex; align-items: center">
    <i class="material-symbols-outlined search-icon" (click)="onSearchIconClick($event)">search</i>
  </div>

  <input
    #address_search
    class="search-input"
    [ngClass]="isAddressSearchType && expanded ? 'visible' : 'hidden'"
    placeholder="{{ T.settings.location_manager.type_address_place | translate }}..."
    (click)="dropdownOpen = false"
  />
  <input
    #what_three_words_search
    class="search-input"
    [ngClass]="isWhatThreeWordsSearchType && expanded ? 'visible' : 'hidden'"
    placeholder="{{ T.settings.location_manager.type_three_word_address | translate }}..."
    (click)="dropdownOpen = false"
  />
  <input
    #zones_areas_search
    class="search-input"
    [ngClass]="isZonesAreasSeachType && expanded ? 'visible' : 'hidden'"
    placeholder="{{ T.settings.location_manager.type_zone_area_title | translate: {
        localisedZone: localisedZone,
        localisedArea: localisedArea
      }
    }}..."
    (keyup)="onZoneAreaSearchInputChange($event, zones_areas_search.value)"
    (click)="dropdownOpen = false"
  />
  <input
    #venue_maps_search
    class="search-input"
    [(ngModel)]="venueMapsSeachInputValue"
    [ngClass]="isVenueMapsSearchType && expanded ? 'visible' : 'hidden'"
    placeholder="{{ T.settings.location_manager.type_venue_map_title | translate }}..."
    (keyup)="onVenueMapSearchInputChange($event, venue_maps_search.value)"
    (click)="dropdownOpen = false"
  />
  <ng-container *ngIf="isZonesAreasSeachType && expanded">
    <div class="drawables-search-result-container custom-scrollbar">
      <div class="result" *ngFor="let item of filteredZonesAreas" (click)="onZoneAreaSearchResultClicked($event, item)">
        <i *ngIf="item.type === 0" class="icon material-symbols-outlined">location_searching</i>
        <i *ngIf="item.type === 1" class="icon material-symbols-outlined">my_location</i>
        <span>{{ item.title }}</span>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isVenueMapsSearchType && expanded">
    <div class="drawables-search-result-container custom-scrollbar">
      <div class="result" *ngFor="let item of filteredVenueMaps" (click)="onVenueMapSearchResultClicked($event, item)">
        <i class="icon material-symbols-outlined">map</i>
        <span>{{ item.title }}</span>
      </div>
    </div>
  </ng-container>

  <div *ngIf="expanded" style="height: 100%">
    <i class="material-symbols-outlined arrow-down-icon" (click)="onDropdownIconClick($event)">arrow_drop_down </i>
  </div>
  <div *ngIf="dropdownOpen" class="list-wrapper">
    <a *ngIf="enableAddressSearch"
      [ngClass]="{'active': isAddressSearchType}"
      (click)="onSearchTypeChange($event, searchTypes.ADDRESS_PLACES)">
      {{ T.common.addresses_or_places | translate }}
    </a>
    <a *ngIf="enableWhat3WordSearch"
      [ngClass]="{'active': isWhatThreeWordsSearchType}"
      (click)="onSearchTypeChange($event, searchTypes.WHAT3WORDS)">
      what3words {{ T.common.address | translate }}
    </a>
    <a *ngIf="enableZonesAreasSearch"
      [ngClass]="{'active': isZonesAreasSeachType}"
      (click)="onSearchTypeChange($event, searchTypes.ZONES_AREAS)">
      {{ localisedZones}} & {{ localisedAreas }}
    </a>
    <a *ngIf="enableVenueMapsSearch"
      [ngClass]="{'active': isVenueMapsSearchType}"
      (click)="onSearchTypeChange($event, searchTypes.VENUE_MAPS)">
      {{ T.defaultLocalizations.venue_map.many | translate }}
    </a>
  </div>
</div>
